import { defineComponent, openBlock, createElementBlock, withDirectives, createVNode, unref, vShow, createElementVNode, withModifiers, Fragment, renderList, createBlock, createCommentVNode } from "vue";
import { CdrRating } from "@rei/cedar";
import ProductTitle from "../ProductTitle/ProductTitle.mjs";
import ProductBadge from "../ProductBadge/ProductBadge.mjs";
import GenericPreorderBanner from "../GenericPreorderBanner/GenericPreorderBanner.mjs";
const _hoisted_1 = {
  class: "product-header"
};
const _hoisted_2 = {
  class: "product-header__ratings-and-id"
};
const _hoisted_3 = {
  key: 0,
  class: "product-header__product-badge"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductHeader",
  props: {
    badges: {
      default: null
    },
    brand: {},
    isPreorder: {
      type: Boolean
    },
    reviewSummary: {},
    showProductBadge: {
      type: Boolean
    },
    title: {}
  },
  emits: ["badgeClick", "metricsClick", "preorderBannerClick", "scrollToReviews"],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleClick = () => {
      emit("scrollToReviews");
      emit("metricsClick", {
        linkName: "star rating"
      });
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [withDirectives(createVNode(unref(GenericPreorderBanner), {
        class: "product-header__preorder",
        onPreorderBannerClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("preorderBannerClick", data))
      }, null, 512), [[vShow, _ctx.isPreorder]]), createVNode(unref(ProductTitle), {
        class: "product-header__product-title",
        title: _ctx.title,
        link: _ctx.brand.link,
        name: _ctx.brand.name,
        onMetricsClick: _cache[1] || (_cache[1] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["title", "link", "name"]), createElementVNode("div", _hoisted_2, [createElementVNode("div", {
        id: "product-rating",
        class: "product-header__rating",
        onClick: withModifiers(handleClick, ["prevent"])
      }, [createVNode(unref(CdrRating), {
        href: "#",
        rating: _ctx.reviewSummary.averageRating,
        count: _ctx.reviewSummary.count,
        size: "small"
      }, null, 8, ["rating", "count"])])]), _ctx.showProductBadge ? (openBlock(), createElementBlock("div", _hoisted_3, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.badges, (badge, index) => {
        return openBlock(), createBlock(unref(ProductBadge), {
          key: index,
          badge,
          "data-ui": "product-badge",
          onBadgeClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("badgeClick", data)),
          onMetricsClick: _cache[3] || (_cache[3] = (data) => _ctx.$emit("metricsClick", data))
        }, null, 8, ["badge"]);
      }), 128))])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductHeader2.mjs.map
